export default class TotalAdjustmentAmountCalculationError extends Error {
    constructor(message: string) {
        super(message);
        Object.setPrototypeOf(this, TotalAdjustmentAmountCalculationError.prototype);
    }
}
